module.exports = __webpack_public_path__ + "static/img/pikto_info.f952fe16.svg";